// components/FeaturesSection.js
import React from "react";
// You might use a library like react-icons for icons, or just use images/SVGs
import { BiDollar, BiTargetLock, BiTime } from "react-icons/bi"; // Example icons

function FeaturesSection() {
  return (
    <section className="py-12">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Curated Marketing Quality
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Exponent theme is insanely flexible and amazingly easy to use. This alone would be enough for a 5 star rating.
          </p>
        </div>
        <div className="flex flex-wrap -mx-4 text-center">
          {/* Feature 1 */}
          <div className="w-full md:w-1/3 px-4 mb-12">
            <div className="bg-white shadow-md rounded-lg mb-10 border border-transparent h-full p-6 flex flex-col items-center justify-center hover:shadow-xl hover:-translate-y-2 hover:border-customcolor">
              <BiDollar size={48} className="text-customcolor mb-4" />{" "}
              {/* Example icon */}
              <h3 className="text-xl font-semibold mb-2">Pay Fixed Price</h3>
              <p className="text-gray-600">
                Ensure budget certainty with our fixed-price projects, providing
                clear costs upfront for your peace of mind.
              </p>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="w-full md:w-1/3 px-4 mb-12">
            <div className="bg-white shadow-md rounded-lg mb-10 border border-transparent h-full p-6 flex flex-col items-center justify-center hover:shadow-xl hover:-translate-y-2 hover:border-customcolor">
              <BiTargetLock size={48} className="text-customcolor mb-4" />
              <h3 className="text-xl font-semibold mb-2">Quality Work</h3>
              <p className="text-gray-600">
                Access top-tier talent committed to delivering high-quality
                results that meet your project's exact specifications.
              </p>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="w-full md:w-1/3 px-4 mb-12">
            <div className="bg-white shadow-md rounded-lg mb-10 border border-transparent h-full p-6 flex flex-col items-center justify-center hover:shadow-xl hover:-translate-y-2 hover:border-customcolor">
              <BiTime size={48} className="text-customcolor mb-4" />
              <h3 className="text-xl font-semibold mb-2">Fast & Safe</h3>
              <p className="text-gray-600">
                Experience swift project completion and secure transactions with
                our robust platform designed for efficiency and safety.
              </p>
            </div>
          </div>

          {/* Feature 4 */}
          <div className="w-full md:w-1/3 px-4 mb-12">
            <div className="bg-white shadow-md rounded-lg mb-10 border border-transparent h-full p-6 flex flex-col items-center justify-center hover:shadow-xl hover:-translate-y-2 hover:border-customcolor">
              <BiDollar size={48} className="text-customcolor mb-4" />{" "}
              {/* Example icon */}
              <h3 className="text-xl font-semibold mb-2">Pay Fixed Price</h3>
              <p className="text-gray-600">
                Ensure budget certainty with our fixed-price projects, providing
                clear costs upfront for your peace of mind.
              </p>
            </div>
          </div>

          {/* Feature 5 */}
          <div className="w-full md:w-1/3 px-4 mb-12">
            <div className="bg-white shadow-md rounded-lg mb-10 border border-transparent h-full p-6 flex flex-col items-center justify-center hover:shadow-xl hover:-translate-y-2 hover:border-customcolor">
              <BiTargetLock size={48} className="text-customcolor mb-4" />
              <h3 className="text-xl font-semibold mb-2">Quality Work</h3>
              <p className="text-gray-600">
                Access top-tier talent committed to delivering high-quality
                results that meet your project's exact specifications.
              </p>
            </div>
          </div>

          {/* Feature 6 */}
          <div className="w-full md:w-1/3 px-4 mb-12">
            <div className="bg-white shadow-md rounded-lg mb-10 border border-transparent h-full p-6 flex flex-col items-center justify-center hover:shadow-xl hover:-translate-y-2 hover:border-customcolor">
              <BiTime size={48} className="text-customcolor mb-4" />
              <h3 className="text-xl font-semibold mb-2">Fast & Safe</h3>
              <p className="text-gray-600">
                Experience swift project completion and secure transactions with
                our robust platform designed for efficiency and safety.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection;
